import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsDto } from '@app/news/@shared/models/NewsDto';
import { MbResponse } from '@montblancsimpl/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class NewsCarouselService {
  constructor(private httpClient: HttpClient) {}

  get(isCarousel: boolean = false): Observable<NewsDto[]> {
    const today = this.formatDate(new Date());

    let newsForCarousel: string = isCarousel
      ? `&effectiveFrom<=${today}&effectiveToFilter>${today}`
      : '';

    return this.httpClient.get<MbResponse<NewsDto[]>>(`news?sort=order${newsForCarousel}`).pipe(
      map((response: MbResponse<NewsDto[]>) => {
        return response.data;
      }),
    );
  }

  private formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
